<div
  class="nav-sidebar-item"
  [class.active]="active"
  [class.danger]="danger"
  [class.disabled]="disabled"
  role="button"
  [attr.tabindex]="disabled ? -1 : 0"
  [attr.aria-disabled]="disabled"
  [style.padding-left.px]="paddingLeft"
  (click)="handleClick($event)"
  (keydown.enter)="handleClick($event)"
  (keydown.space)="handleClick($event)"
>
  <span class="nav-sidebar-item__content">
    <app-pencil-spinner
      *ngIf="loading; else itemIcon"
      class="nav-sidebar-item__spinner"
      [strokeWidth]="2"
    ></app-pencil-spinner>

    <ng-template #itemIcon>
      <app-pencil-icon
        *ngIf="icon"
        class="nav-sidebar-item__icon"
        [name]="icon"
        [type]="iconType"
      ></app-pencil-icon>
    </ng-template>

    <span class="nav-sidebar-item__label" [class.nav-sidebar-item__label--bold]="bold">
      {{ label }}
    </span>
  </span>
  <span *ngIf="badge && badge > 0" class="nav-sidebar-item__badge">
    {{ badge | navBadgeFormat }}
  </span>
  <app-pencil-button
    *ngIf="menuContent"
    class="nav-sidebar-item__menu-btn"
    [class.nav-sidebar-item__menu-btn--open]="isMenuOpen$ | async"
    icon="ellipsis"
    [iconConfig]="{ type: IconTypes.lucideIcon }"
    [theme]="PencilButtonThemeEnum.ICON"
    buttonType="button"
    [disabled]="disabled"
    [attr.aria-label]="label"
    [matMenuTriggerFor]="(screenSizeService.renderMenuAsBottomSheet$ | async) ? null : itemMenu"
    (menuOpened)="onMenuOpened()"
    (menuClosed)="onMenuClosed()"
    (click)="onMenuButtonClick($event)"
    (keydown.enter)="onMenuButtonClick($event)"
    (keydown.space)="onMenuButtonClick($event)"
  ></app-pencil-button>
  <app-pencil-icon
    *ngIf="showChevron"
    class="nav-sidebar-item__chevron"
    [class.nav-sidebar-item__chevron--expanded]="expanded"
    [name]="'chevron-down'"
    [type]="IconTypes.lucideIcon"
  ></app-pencil-icon>
</div>

<mat-menu
  #itemMenu="matMenu"
  class="pencil-mat-menu light-scheme"
  xPosition="after"
  yPosition="above"
>
  <!--
    Without the injector the submenu opens on top of this menu instead of beside it. menuContent is
    declared by the parent, and an embedded view resolves DI from where it was declared rather than
    where it's inserted — so a MatMenuTrigger inside it never sees this panel's MAT_MENU_PANEL and
    Material stops treating it as a submenu. Verified by removing it.
  -->
  <ng-container
    *ngTemplateOutlet="
      menuContent;
      context: { $implicit: menuContext };
      injector: menuPanelInjector
    "
  ></ng-container>
</mat-menu>

<ng-template #bottomSheetContainer>
  <app-pencil-bottom-sheet-container
    [title]="label"
    [colorScheme]="ColorScheme.LIGHT"
    (closeClicked)="dismissBottomSheet()"
  >
    <ng-container
      *ngTemplateOutlet="menuContent; context: { $implicit: menuContext }"
    ></ng-container>
  </app-pencil-bottom-sheet-container>
</ng-template>
